































import { Component, Vue, Inject, Ref, Watch } from 'vue-property-decorator';

import ContattoList from './ContattoList.vue';
import EditContatto from './contatto/EditContatto.vue';
import { CrudService } from '@/data/services/crud.service';
import { Contatto } from '@/data/models/contatto.model';
import ContattoFilter from './ContattoFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { BModalComponent } from 'buefy/types/components';

@Component({
	components: {
		ContattoList,
		EditContatto,
		ContattoFilter,
	},
})
export default class Contatti extends Vue {
	@Inject('CrudService') crudService!: CrudService<Contatto>;

	@Ref('list') list!: ContattoList;
	@Ref('filter') filter!: ContattoFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadContatti();
	}

	saveContatto(value: Contatto, modal: BModalComponent) {
		value.hqid = this.state.headquarter!.id;
		this.crudService
			.createEntity(Contatto, 'contact', value)
			.then(() => {
				this.list.loadContatti();
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				modal.close();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	addContatto() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditContatto,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Contatto) => {
					this.saveContatto(value, modal);
				}
			}
		});
	}

	editContatto(item: Contatto) {
		this.openContatto(item);
	}

	openContatto(item: Contatto) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditContatto,
			props: {
				contatto: item,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Contatto) => {
					this.saveContatto(value, modal);
				},
			},
		});
	}

	deleteContatto(item: Contatto) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-contatto-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Contatto, 'contact', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.list.loadContatti();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

}
